import { Card, CardActions, TextField, Typography } from "@mui/material";
import styled from "styled-components";
import { ErrorRecord, Product } from "../../types";
import { CircleDollarSign } from "lucide-react";
import { sx } from "../../utils/util";
export type Props = {
    product: Product;
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    error: boolean;
    errors: ErrorRecord<Product>;
};

export const PriceForm = (props: Props) => {
    return (
        <Container>
            <Card
                variant="outlined"
                sx={{
                    borderRadius: "30px",
                    width: "90%",
                    overflowY: "auto",
                    maxHeight: "80vh",
                    padding: "5px",
                    marginBottom: "30px",
                }}
            >
                <StyledCardActions>
                    <IconActionsWrapper>
                        <CircleDollarSign />{" "}
                        <Typography
                            fontFamily={"'Poppins', sans-serif"}
                            fontSize={18}
                            color="#8c8c8c"
                            fontWeight={600}
                        >
                            Price
                        </Typography>
                    </IconActionsWrapper>
                </StyledCardActions>
                <Form id="partial-submit-form" autoComplete="off">
                    <TextField
                        label="Sales price"
                        name="netPrice"
                        variant="outlined"
                        type="number"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        onChange={e => props.handleChange(e)}
                        value={props.product.netPrice}
                        error={props.errors.netPrice ? true : false}
                        helperText={props.errors.netPrice}
                        sx={{ ...sx, marginTop: "20px" }}
                    />
                    <TextField
                        label="Purchase price"
                        name="purchasePrice"
                        variant="outlined"
                        type="number"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        onChange={e => props.handleChange(e)}
                        value={props.product.purchasePrice}
                        error={props.errors.purchasePrice ? true : false}
                        helperText={props.errors.purchasePrice}
                        sx={sx}
                    />
                    <TextField
                        label="Market price"
                        name="marketPrice"
                        variant="outlined"
                        type="number"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        onChange={e => props.handleChange(e)}
                        value={props.product.marketPrice}
                        error={props.errors.marketPrice ? true : false}
                        helperText={props.errors.marketPrice}
                        sx={sx}
                    />
                    <TextField
                        label="CO2e (kg)"
                        name="co2e"
                        variant="outlined"
                        type="number"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        onChange={e => props.handleChange(e)}
                        value={props.product.co2e}
                        error={props.errors.co2e ? true : false}
                        helperText={props.errors.co2e}
                        sx={{ ...sx, marginBottom: "20px" }}
                    />
                </Form>
            </Card>
        </Container>
    );
};

const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-content: center;
    width: 95%;
    margin: 0 auto;
    gap: 20px;
`;
const IconActionsWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    gap: 5px;
`;
const StyledCardActions = styled(CardActions)`
    display: flex;
    width: 100%;
    font-size: 3rem;
    border-bottom: 1px solid #ebebeb;
    //background-color: #ebebeb;
    align-items: center; /* Centrerar vertikalt i flex-container */
`;
const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`;
